export const ActionButton = 'mb-3 sm:mb-0 sm:mr-3'

export const ConfirmationHeadline = 'text-black'

export const ConfirmationDescription = 'w-full'

export const ConfirmationButtonsWrapper = 'flex w-full pt-4'

export const ConfirmationCancelButton = 'mr-2'
